<template>
    <svg viewBox="0 0 1720 168" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path
            d="M1699.09 45.78C1692.58 25.3301 1677.94 14.8727 1656.33 14.8727C1638.66 14.8727 1621.47 22.7738 1621.47 41.8294C1621.47 60.6527 1636.57 69.7158 1665.39 75.0606C1704.89 82.497 1720 95.9753 1720 119.911C1720 148.03 1694.9 167.318 1661.44 167.318C1633.09 167.318 1605.9 153.607 1594.28 117.82L1608.45 108.989C1615.89 135.016 1632.86 152.445 1661.67 152.445C1686.77 152.445 1703.73 140.361 1703.73 120.143C1703.73 105.038 1694.21 95.0458 1659.81 89.2362C1628.44 83.8913 1605.2 68.7862 1605.2 42.2942C1605.2 18.8233 1625.42 0 1657.49 0C1683.52 0 1704.89 13.0136 1713.49 37.6465L1699.09 45.78Z"
            fill="currentColor"
        />
        <path
            d="M1468.23 2.32385H1577.92V17.1965H1484.5V73.4339H1570.95V88.3066H1484.5V150.121H1580.24V164.994H1468.23V2.32385Z"
            fill="currentColor"
        />
        <path d="M1372.46 153.375L1434.74 2.32385H1451.47L1383.85 164.994H1361.08L1293.45 2.32385H1310.18L1372.46 153.375Z" fill="currentColor" />
        <path d="M1260.34 164.994V2.32385H1276.61V164.994H1260.34Z" fill="currentColor" />
        <path
            d="M1065.19 164.994L1024.76 2.32385H1042.19L1079.37 155.234L1119.57 2.32385H1148.39L1188.59 155.234L1225.77 2.32385H1243.2L1202.76 164.994H1174.65L1133.98 12.0841L1093.31 164.994H1065.19Z"
            fill="currentColor"
        />
        <path
            d="M877.718 164.994V2.32385H936.976C988.101 2.32385 1015.99 36.4846 1015.99 83.6589C1015.99 130.833 988.101 164.994 936.976 164.994H877.718ZM893.985 17.1965V150.121H936.976C976.947 150.121 999.72 124.791 999.72 83.6589C999.72 42.5266 976.947 17.1965 936.976 17.1965H893.985Z"
            fill="currentColor"
        />
        <path d="M828.812 164.994V2.32385H845.079V164.994H828.812Z" fill="currentColor" />
        <path
            d="M796.174 164.994H779.907V10.225L717.395 164.994H693.692L631.18 10.225V164.994H614.913V2.32385H644.891L705.544 153.607L766.197 2.32385H796.174V164.994Z"
            fill="currentColor"
        />
        <path
            d="M421.554 2.32385H531.24V17.1965H437.821V73.4339H524.269V88.3066H437.821V150.121H533.564V164.994H421.554V2.32385Z"
            fill="currentColor"
        />
        <path d="M280.734 2.32385H297.001V150.121H398.786V164.994H280.734V2.32385Z" fill="currentColor" />
        <path d="M139.914 2.32385H156.181V150.121H257.966V164.994H139.914V2.32385Z" fill="currentColor" />
        <path d="M0 2.32385H109.686V17.1965H16.267V73.4339H102.715V88.3066H16.267V150.121H112.01V164.994H0V2.32385Z" fill="currentColor" />
    </svg>
</template>
